import { useState } from "react";
import "./AdminUserSearch.css";

function AdminUserSearch() {
  const [filters, setFilters] = useState({
    userId: "",
    email: "",
    phone: "",
    username: "",
    name: "",
    ip: "",
    country: "",
    countryCode: "",
    region: "",
    city: "",
  });

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [purpose, setPurpose] = useState("");

  const updateFilter = (field, value) => {
    setFilters((current) => ({
      ...current,
      [field]: value,
    }));
  };

  const handleSearch = async (event) => {
    event.preventDefault();

    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value.trim()) {
        params.set(key, value.trim());
      }
    });

    if (!params.toString()) {
      setUsers([]);
      setError("Enter at least one search filter.");
      return;
    }
    if (purpose.trim().length < 10) {
      setError("Add a short support reason for this customer search (at least 10 characters).");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/admin/search-users", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...Object.fromEntries(params.entries()), purpose: purpose.trim() })
      });

      if (!response.ok) {
        const failure = await response.json().catch(() => ({}));
        throw new Error(failure.error || "Search unavailable");
      }

      const data = await response.json();

      if (data.ok && Array.isArray(data.users)) {
        setUsers(data.users);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Admin user search error:", error);
      setUsers([]);
      setError(error.message === "Failed to fetch"
        ? "Search service unavailable. Check the local admin backend and LAB database."
        : error.message);
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    ["userId", "User ID"],
    ["email", "Email"],
    ["phone", "Phone"],
    ["username", "Username / Pseudo"],
    ["name", "Name"],
    ["ip", "IP Address"],
    ["country", "Country"],
    ["countryCode", "Country Code"],
    ["region", "Region / State"],
    ["city", "City"],
  ];

  return (
    <section className="bubly-admin-user-search">
      <div className="bubly-admin-panel">
        <div className="bubly-admin-panel-header">
          <span>SUPPORT WORKSPACE</span>
          <h2>Find a customer</h2>
        </div>

        <form onSubmit={handleSearch}>
          <div className="admin-search-grid">
            {fields.map(([field, label]) => (
              <label key={field}>
                <span>{label}</span>
                <input
                  type="text"
                  value={filters[field]}
                  onChange={(event) => updateFilter(field, event.target.value)}
                />
              </label>
            ))}
          </div>

          <label className="admin-search-purpose">
            <span>Reason for this search</span>
            <textarea value={purpose} onChange={(event) => setPurpose(event.target.value)} minLength={10} maxLength={500} placeholder="Support case, account access request, legal request reference…" required />
          </label>

          <button type="submit" disabled={loading}>
            {loading ? "Searching…" : "Search customers"}
          </button>
        </form>

        {error && <p className="admin-search-error" role="alert">{error}</p>}

        <div className="admin-search-results">
          {users.map((user) => (
            <div className="admin-search-result" key={user.id}>
              <strong>
                {user.name || user.username || "Unnamed account"}
              </strong>

              <span>{user.email}</span>

              <span>
                User #{user.id}
                {user.geo_city ? ` · ${user.geo_city}` : ""}
                {user.geo_country ? ` · ${user.geo_country}` : ""}
              </span>
<button
  type="button"
  className="admin-search-manage"
  onClick={() => {
    window.location.href = `/admin/users/${user.id}`;
  }}
>
  Manage
</button>
            </div>
          ))}

          {!loading && users.length === 0 && (
            <div className="admin-search-empty">
              No users found.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default AdminUserSearch;
